import { Button } from '../../components';
import React from 'react';
import { MasterConditionManagement } from '../../services';
import warning from '../../assets/svg/warning.svg';
import  '../Modal/Modal.global.scss';

interface Props {
  handleModalClose: any;
  id: any;
  fetchPriceList: any;
  status: any;
}
const MasterConditionManagementBlocked: React.FC<Props> = (props: Props) => {
  const {
    handleModalClose,
    id,
    fetchPriceList,
    status,
  } = props;
  // id: "age"
  const [blocked, setBlocked] = React.useState(false);
  const blockService = () => {
    const obj: any = {};
    const enableKeys: any = {
      age: 'isMinimumAgeEnable',
      existance: 'isMinimumAccountAgeEnable',
      havingPremiumSubscription: 'isHavingPremiumSubscriptionEnable',
      noOfFollowers: 'isNoOfFollowersEnable',
      sessionDuration: 'isSessionDurationEnable',
    };
    if (enableKeys[id]) {
      obj[enableKeys[id]] = status !== 'blocked';
    }
    MasterConditionManagement
      .activateDeactivate(obj).then(() => {
        setBlocked(true);
      });
  };

  return (
    <>
      {!blocked ? (
        <>
          <img src={warning} alt="warning" />
          <h2>
            {status === 'blocked' ? 'Block' : 'Unblock'}
            {' '}
          </h2>
          <p>
            Are you sure you want to
            {' '}
            {status === 'blocked' ? 'block' : 'unblock'}
            {' '}
            this entry?
          </p>
          <div className="modalButtonWrapper">
            <Button onClick={handleModalClose}>No</Button>
            <Button intent={status === 'blocked' ? 'danger' : 'primary'} onClick={blockService}>Yes</Button>
          </div>
        </>
      ) : (
        <>
          <h3>
            Entry
            {' '}
            {status === 'blocked' ? 'blocked' : 'unblocked'}
            {' '}
            successfully !
          </h3>
          <Button onClick={() => {
            handleModalClose();
            fetchPriceList();
          }}
          >
            Ok
          </Button>
        </>
      )}

    </>
  );
};

export default MasterConditionManagementBlocked;
